import React from 'react';
import PropTypes from 'prop-types';
import CookieNotice from 'src/uikit/CookieNotice';
import TopBar from 'src/components/TopBar';
import bgLogo from 'src/assets/img/bgLogo.svg';
import OfflineMsg from 'src/uikit/OfflineMsg';
import SyncingMsg from 'src/uikit/SyncingMsg';
import SuccessToast from 'src/uikit/SuccessToast';
import styles from './InnerPageLayout.module.scss';

const InnerPageLayout = ({ children }) => (
  <div className={styles.wrapper} style={{ backgroundImage: `url(${bgLogo})` }}>
    <OfflineMsg />
    <SyncingMsg />
    <SuccessToast />
    <TopBar />
    <div className={styles.inner}>{children}</div>
    <CookieNotice />
  </div>
);

export default InnerPageLayout;

InnerPageLayout.propTypes = {
  children: PropTypes.node,
};

InnerPageLayout.defaultProps = {
  children: null,
};
